import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PilotChannelTitle = styled.span<React.CSSProperties>`
  color: ${Colors['text']};
  font-size: ${32 * Screen.widthRatio}px;
  font-family: ${Fonts['light']};
  line-height: ${50 * Screen.widthRatio}px;
  margin-right: ${32 * Screen.widthRatio}px;
`;

export default PilotChannelTitle;
